import { render, staticRenderFns } from "./board-members-item.vue?vue&type=template&id=ebd1cef8&scoped=true&"
import script from "./board-members-item.vue?vue&type=script&lang=js&"
export * from "./board-members-item.vue?vue&type=script&lang=js&"
import style0 from "./board-members-item.vue?vue&type=style&index=0&id=ebd1cef8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd1cef8",
  null
  
)

export default component.exports